import React from "react";

const Component = () => (
  <div data-testid="placeholder">
    <h1>Brand Assets</h1>
    <p>Download brand assets.</p>
  </div>
);

export default Component;

